/*
 * @Description: 退货单[csg]
 */
import { generate } from '@/utils/request';

const config = {
  prefix: '/third-adapter/v1/{organizationId}/third-party-return-order-header',
  items: [
    // 创建退货单
    {
      key: 'addThirdPartyReturnOrder',
      url: '/create-thirdParty-return-order',
      method: 'POST',
    },
    // 编辑退货单
    {
      key: 'editThirdPartyReturnOrder',
      url: '/update-thirdParty-return-order',
      method: 'PUT',
    },
    // 退货单详情
    {
        key: 'detailThirdPartyReturnOrder',
        url: '/detail',
        method: 'POST',
    },
    // 退货单列表页
    {
        key: 'getThirdOrderCanReturnGoods',
        url: '/order-page',
        method: 'POST',
      },
  ],
};

export default {
  ...generate(config),
};
